module.exports = __webpack_public_path__ + "static/img/arthroscopy-detail-10.d8abf39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-detail-10.jpg
// module id = 5EP5
// module chunks = 51